"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Prices = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _hooks = require("../../hooks");
var _MainPrice = require("./MainPrice");
var _PriceLabel = require("./PriceLabel");
var _constants = require("./constants");
var _styles = require("./styles");
var _utils = require("./utils");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Displays current price, catalogue price, and price after immediate discount.
 * If user is member, vip or anonymous, only current price is displayed.
 * If user is a brand partner, current price, catalogue price, and price after immediate discount are displayed.
 * If there is a difference between current price and catalogue price, catalogue price is crossed out.
 *
 */
const Prices = ({
  currentPrice,
  cataloguePrice,
  className,
  priceAfterImmediateDiscount,
  customerTypeId,
  mrpStatementEnabled,
  size = 'medium'
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    translations
  } = (0, _hooks.useTranslations)();
  if (!currentPrice && !priceAfterImmediateDiscount && !cataloguePrice) {
    return null;
  }
  const oldPriceVisible = (0, _utils.isOldPriceVisible)({
    cataloguePrice,
    currentPrice
  });
  const isBrandPartner = customerTypeId === _constants.BRAND_PARTNER_ID;
  const immediateDiscountPriceVisible = isBrandPartner && Boolean(priceAfterImmediateDiscount);
  const mainPrice = priceAfterImmediateDiscount != null && priceAfterImmediateDiscount !== '' ? priceAfterImmediateDiscount : currentPrice;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
    className: className,
    "data-testid": getTestId(_constants.PRICES),
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_MainPrice.MainPrice, {
        immediateDiscountPriceVisible: immediateDiscountPriceVisible,
        mrpStatementEnabled: mrpStatementEnabled,
        oldPriceVisible: oldPriceVisible,
        price: mainPrice,
        size: size
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_PriceLabel.PriceLabel, {
        cataloguePrice: cataloguePrice,
        currentPrice: currentPrice,
        immediateDiscountPriceVisible: immediateDiscountPriceVisible,
        mrpStatementEnabled: mrpStatementEnabled,
        oldPriceVisible: oldPriceVisible,
        title: (0, _utils.getOldPriceTitle)({
          isBrandPartner,
          translations,
          mrpStatementEnabled
        })
      })]
    })
  });
};
exports.Prices = Prices;
//# sourceMappingURL=Prices.js.map